import { ref } from 'vue'

/**
 * Create and export state for use-trends composable
 */
export const createTrendsState = () => {
  const isLoadingTrends = ref(false)
  const trendsList = ref([])
  const selectedTrend = ref(null)
  const selectedTrendType = ref('')
  
  return {
    isLoadingTrends,
    trendsList,
    selectedTrend,
    selectedTrendType,
  }
}
